import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../logo.PNG';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      let current = '';

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        if (window.pageYOffset >= sectionTop - sectionHeight / 3) {
          current = section.getAttribute('id');
        }
      });

      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false); // Close the menu when a link is clicked
  };

  return (
    <nav className="navbar" dir="rtl">
      <div className="navbar-brand">
        <img src={logo} alt="Falcons Logo" className="navbar-logo" />
        <span className="navbar-logo-text">FALCONS</span>
      </div>
      <div className="menu-toggle" onClick={toggleMenu}>
        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <a href="#home" className={activeSection === 'home' ? 'active' : ''} onClick={handleLinkClick}>الرئيسية</a>
        <a href="#about" className={activeSection === 'about' ? 'active' : ''} onClick={handleLinkClick}>من نحن</a>
        <a href="#services" className={activeSection === 'services' ? 'active' : ''} onClick={handleLinkClick}>خدماتنا</a>
        <a href="#portfolio" className={activeSection === 'portfolio' ? 'active' : ''} onClick={handleLinkClick}>أعمالنا</a>
        <a href="#contact" className={activeSection === 'contact' ? 'active' : ''} onClick={handleLinkClick}>تواصل معنا</a>
      </div>
    </nav>
  );
};

export default Navbar;
